/**
 * 所有 API 请求封装
 */
import client from './client';

// ========== 认证 ==========
export const authApi = {
  login: (data) => client.post('/auth/login', data).then(r => r.data.data),
  register: (data) => client.post('/auth/register', data).then(r => r.data.data),
  refresh: (refreshToken) => client.post('/auth/refresh', { refreshToken }).then(r => r.data.data),
  logout: () => client.post('/auth/logout'),
  getCaptchaImage: (sessionId) => client.get('/auth/captcha/image', { params: { sessionId } }).then(r => r.data.data),
  sendOtp: (email) => client.post('/auth/otp/send', { email }).then(r => r.data.data),
  checkOtpRequired: (email) => client.get('/auth/otp/check', { params: { email } }).then(r => r.data.data),
  // 密码重置
  sendResetEmail: (email, baseUrl) => client.post('/auth/password/reset/send', { email, baseUrl }).then(r => r.data.data),
  validateResetToken: (token) => client.get('/auth/password/reset/validate', { params: { token } }).then(r => r.data.data),
  resetPassword: (token, password) => client.post('/auth/password/reset', { token, password }).then(r => r.data.data),
};

// ========== 商品（前台） ==========
export const productApi = {
  list: (params) => client.get('/storefront/products', { params }).then(r => r.data.data),
  getById: (id) => client.get(`/storefront/products/${id}`).then(r => r.data.data),
  getBySlug: (slug) => client.get(`/storefront/products/slug/${slug}`).then(r => r.data.data),
  listCategories: () => client.get('/storefront/categories').then(r => r.data.data),
  getCategoryBySlug: (slug) => client.get(`/storefront/categories/${slug}`).then(r => r.data.data),
  getSettings: () => client.get('/storefront/settings').then(r => r.data.data),
};

// ========== 购物车 ==========
export const cartApi = {
  getCart: () => client.get('/cart').then(r => r.data.data),
  addItem: (data) => client.post('/cart/items', data).then(r => r.data.data),
  updateItem: (itemId, quantity) => client.put(`/cart/items/${itemId}`, null, { params: { quantity } }).then(r => r.data.data),
  removeItem: (itemId) => client.delete(`/cart/items/${itemId}`).then(r => r.data.data),
  mergeCart: () => client.post('/cart/merge').then(r => r.data.data),
  clearCart: () => client.delete('/cart').then(r => r.data.data),
};

// ========== 订单（前台） ==========
export const orderApi = {
  checkout: (data) => client.post('/orders/checkout', data).then(r => r.data.data),
  pay: (abandonedOrderId, vendor) => client.post(`/orders/${abandonedOrderId}/pay`, null, { params: { vendor } }).then(r => r.data.data),
  myOrders: (params) => client.get('/orders/my', { params }).then(r => r.data.data),
  getOrder: (id) => client.get(`/orders/${id}`).then(r => r.data.data),
  getByOrderNo: (orderNo) => client.get(`/orders/no/${orderNo}`).then(r => r.data.data),
  getByAbandonedOrderNo: (abandonedOrderNo) => client.get(`/orders/abandoned/${abandonedOrderNo}`).then(r => r.data.data),
  queryPaymentStatus: (abandonedOrderNo) => client.get('/orders/payment/status', { params: { abandonedOrderNo } }).then(r => r.data.data),
};

// ========== 优惠码 ==========
export const discountApi = {
  validate: (code, subtotal, items) => {
    // 传入购物车商品，供后端校验商品限定优惠码的适用范围
    const itemProductIds = (items || []).map(item => item.productId).filter(id => id);
    const quantities = (items || []).map(item => item.quantity).filter(q => q);
    return client.get('/discounts/validate', { params: { code, subtotal, itemProductIds, quantities } }).then(r => r.data.data);
  },
  applyAuto: (subtotal, items) => {
    // items 是购物车商品数组，每个包含 productId 和 quantity
    const itemProductIds = (items || []).map(item => item.productId).filter(id => id);
    const quantities = (items || []).map(item => item.quantity).filter(q => q);
    return client.get('/discounts/auto', { params: { subtotal, itemProductIds, quantities } }).then(r => r.data.data);
  },
};

// ========== 用户个人中心 ==========
export const customerApi = {
  getProfile: () => client.get('/customer/profile').then(r => r.data.data),
  updateProfile: (data) => client.put('/customer/profile', data).then(r => r.data.data),
  changePassword: (data) => client.put('/customer/password', data).then(r => r.data.data),
  getAddresses: () => client.get('/customer/addresses').then(r => r.data.data),
  addAddress: (data) => client.post('/customer/addresses', data).then(r => r.data.data),
  updateAddress: (id, data) => client.put(`/customer/addresses/${id}`, data).then(r => r.data.data),
  deleteAddress: (id) => client.delete(`/customer/addresses/${id}`),
};

// ========== 后台管理 ==========

export const adminDashboardApi = {
  getStats: (date) => client.get('/admin/dashboard', { params: { date } }).then(r => r.data.data),
};

export const adminProductApi = {
  list: (params) => client.get('/admin/products', { params }).then(r => r.data.data),
  getById: (id) => client.get(`/admin/products/${id}`).then(r => r.data.data),
  create: (data) => client.post('/admin/products', data).then(r => r.data.data),
  update: (id, data) => client.put(`/admin/products/${id}`, data).then(r => r.data.data),
  delete: (id) => client.delete(`/admin/products/${id}`),
  uploadImage: (id, formData) => client.post(`/admin/products/${id}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data.data),
  deleteImage: (imageId) => client.delete(`/admin/products/images/${imageId}`),
  listCategories: () => client.get('/admin/categories').then(r => r.data.data),
  createCategory: (data) => client.post('/admin/categories', data).then(r => r.data.data),
  updateCategory: (id, data) => client.put(`/admin/categories/${id}`, data).then(r => r.data.data),
  deleteCategory: (id) => client.delete(`/admin/categories/${id}`),
};

export const adminOrderApi = {
  list: (params) => client.get('/admin/orders', { params }).then(r => r.data.data),
  getById: (id) => client.get(`/admin/orders/${id}`).then(r => r.data.data),
  update: (id, data) => client.put(`/admin/orders/${id}`, data).then(r => r.data.data),
  updateStatus: (id, status) => client.put(`/admin/orders/${id}/status`, null, { params: { status } }).then(r => r.data.data),
  cancel: (id) => client.post(`/admin/orders/${id}/cancel`).then(r => r.data.data),
  createDraft: (data) => client.post('/admin/orders/draft', data).then(r => r.data.data),
  refund: (orderId, paymentId, amount, reason, otp) =>
    client.post(`/admin/orders/${orderId}/refund`, null, { params: { paymentId, amount, reason, otp } }),
  sendRefundOtp: (orderId) =>
    client.post(`/admin/orders/${orderId}/refund/otp`).then(r => r.data.data),
  getRefunds: (orderId) => client.get(`/admin/orders/${orderId}/refunds`).then(r => r.data.data),
  delete: (id) => client.delete(`/admin/orders/${id}`).then(r => r.data),
  batchDelete: (ids) => client.delete('/admin/orders/batch', { data: { ids } }).then(r => r.data),
  ship: (id, data) => client.post(`/admin/orders/${id}/ship`, data).then(r => r.data.data),
  editItems: (orderId, data) => client.post(`/admin/orders/${orderId}/items/edit`, data).then(r => r.data.data),
  exportReport: (startDate, endDate) => client.get('/admin/orders/export', {
    params: { startDate, endDate },
    responseType: 'arraybuffer',
  }).then(r => new Blob([r.data], { type: 'text/csv;charset=utf-8' })),
  sendEmail: (orderId, data) => {
    if (orderId) {
      return client.post(`/admin/orders/${orderId}/email`, data).then(r => r.data);
    } else {
      return client.post('/admin/orders/email', data).then(r => r.data);
    }
  },
};

export const adminAbandonedOrderApi = {
  list: (params) => client.get('/admin/abandoned-orders', { params }).then(r => r.data.data),
  getById: (id) => client.get(`/admin/abandoned-orders/${id}`).then(r => r.data.data),
  getByOrderNo: (orderNo) => client.get(`/admin/abandoned-orders/no/${orderNo}`).then(r => r.data.data),
  recover: (id) => client.post(`/admin/abandoned-orders/${id}/recover`).then(r => r.data.data),
  delete: (id) => client.delete(`/admin/abandoned-orders/${id}`).then(r => r.data),
};

export const adminCartApi = {
  listRecent: (params) => client.get('/admin/carts', { params }).then(r => r.data.data),
};

export const adminPackingSlipApi = {
  getData: (orderIds) => client.get('/admin/packing-slip', { params: { orderIds } }).then(r => r.data.data),
  print: (orderIds) => client.get('/admin/packing-slip/print', {
    params: { orderIds },
    responseType: 'arraybuffer',
  }).then(r => new Blob([r.data], { type: 'application/pdf' })),
};

export const adminUserApi = {
  list: (params) => client.get('/admin/users', { params }).then(r => r.data.data),
  getById: (id) => client.get(`/admin/users/${id}`).then(r => r.data.data),
  getStats: (id) => client.get(`/admin/users/${id}/stats`).then(r => r.data.data),
  getOrders: (id) => client.get(`/admin/users/${id}/orders`).then(r => r.data.data),
  update: (id, data) => client.put(`/admin/users/${id}`, data).then(r => r.data.data),
  resetPassword: (id) => client.post(`/admin/users/${id}/reset-password`).then(r => r.data),
  delete: (id) => client.delete(`/admin/users/${id}`),
  export: () => client.get('/admin/users/export', { responseType: 'blob' }).then(r => r.data),
  import: (formData) => client.post('/admin/users/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000, // 2 分钟超时，用于大文件导入
  }).then(r => r.data.data),
};

export const adminFileApi = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return client.post('/admin/files', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    }).then(r => r.data.data);
  },
  list: (params) => client.get('/admin/files', { params }).then(r => r.data.data),
  delete: (id) => client.delete(`/admin/files/${id}`),
};

export const adminCustomerTagApi = {
  list: () => client.get('/admin/customer-tags').then(r => r.data.data),
  create: (data) => client.post('/admin/customer-tags', data).then(r => r.data.data),
  update: (id, data) => client.put(`/admin/customer-tags/${id}`, data).then(r => r.data.data),
  delete: (id) => client.delete(`/admin/customer-tags/${id}`),
};

export const adminCustomerSegmentApi = {
  list: () => client.get('/admin/customer-segments').then(r => r.data.data),
  getById: (id) => client.get(`/admin/customer-segments/${id}`).then(r => r.data.data),
  getCustomers: (id) => client.get(`/admin/customer-segments/${id}/customers`).then(r => r.data.data),
  create: (data) => client.post('/admin/customer-segments', data).then(r => r.data.data),
  update: (id, data) => client.put(`/admin/customer-segments/${id}`, data).then(r => r.data.data),
  delete: (id) => client.delete(`/admin/customer-segments/${id}`),
  refresh: (id) => client.post(`/admin/customer-segments/${id}/refresh`).then(r => r.data.data),
  addCustomers: (id, customerIds) => client.post(`/admin/customer-segments/${id}/customers/add`, { customerIds }).then(r => r.data.data),
  removeCustomers: (id, customerIds) => client.post(`/admin/customer-segments/${id}/customers/remove`, { customerIds }).then(r => r.data.data),
  exportCustomers: (id) => client.get(`/admin/customer-segments/${id}/export`, {
    responseType: 'arraybuffer',
  }).then(r => new Blob([r.data], { type: 'text/csv;charset=utf-8' })),
};

export const adminDiscountApi = {
  list: (params) => client.get('/admin/discounts', { params }).then(r => r.data.data),
  create: (data) => client.post('/admin/discounts', data).then(r => r.data.data),
  update: (id, data) => client.put(`/admin/discounts/${id}`, data).then(r => r.data.data),
  delete: (id) => client.delete(`/admin/discounts/${id}`),
};

export const adminSettingApi = {
  getSettings: () => client.get('/admin/settings').then(r => r.data.data),
  updateSettings: (data) => client.put('/admin/settings', data).then(r => r.data.data),
  uploadLogo: (formData) => client.post('/admin/settings/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data.data),
  getEmailTemplates: () => client.get('/admin/settings/email-templates').then(r => r.data.data),
  updateEmailTemplate: (id, data) => client.put(`/admin/settings/email-templates/${id}`, data).then(r => r.data.data),
  testSendEmail: (id, data) => client.post(`/admin/settings/email-templates/${id}/test`, data).then(r => r.data),
  testTelegram: () => client.post('/admin/settings/telegram/test').then(r => r.data),
};

export const adminEmailCampaignApi = {
  list: () => client.get('/admin/email-campaigns').then(r => r.data.data),
  getById: (id) => client.get(`/admin/email-campaigns/${id}`).then(r => r.data.data),
  getRecipients: (id) => client.get(`/admin/email-campaigns/${id}/recipients`).then(r => r.data.data),
  getLogs: (id) => client.get(`/admin/email-campaigns/${id}/logs`).then(r => r.data.data),
  getStats: (id) => client.get(`/admin/email-campaigns/${id}/stats`).then(r => r.data.data),
  create: (data) => client.post('/admin/email-campaigns', data).then(r => r.data.data),
  update: (id, data) => client.put(`/admin/email-campaigns/${id}`, data).then(r => r.data.data),
  delete: (id) => client.delete(`/admin/email-campaigns/${id}`),
  send: (id) => client.post(`/admin/email-campaigns/${id}/send`).then(r => r.data.data),
  preview: (id) => client.get(`/admin/email-campaigns/${id}/preview`).then(r => r.data.data),
  sendTest: (id, email) => client.post(`/admin/email-campaigns/${id}/test`, null, { params: { email } }).then(r => r.data.data),
  copy: (id) => client.post(`/admin/email-campaigns/${id}/copy`).then(r => r.data.data),
};

export const adminInventoryApi = {
  list: (params) => client.get('/admin/inventory', { params }).then(r => r.data.data),
  update: (variantId, quantity) => client.put(`/admin/inventory/${variantId}`, null, { params: { quantity } }).then(r => r.data.data),
  batchUpdate: (items) => client.put('/admin/inventory/batch', { items }).then(r => r.data.data),
  getHistory: (variantId, params) => client.get(`/admin/inventory/${variantId}/history`, { params }).then(r => r.data.data),
};
